import { Button } from 'components/common';
import { billing } from 'libs';
import ExitSurvey from './ExitSurvey';
import type { ExitSurveyPayload } from './types';

interface DowngradePlatinumSubscriptionProps {
  isPastDue: boolean;
  onDowngrade: (subscriptionType: string, data: ExitSurveyPayload) => void;
  onHideModal: () => void;
  onShowDowngradePlatinumModal: () => void;
  onTrial: boolean;
  showDowngradePlatinumModal: boolean;
}

const DowngradePlatinumSubscription = ({
  isPastDue,
  onDowngrade,
  onHideModal,
  onShowDowngradePlatinumModal,
  onTrial,
  showDowngradePlatinumModal,
}: DowngradePlatinumSubscriptionProps) => (
  <div className="card" data-testid="subscriptions-downgrade-subscription-card">
    <ExitSurvey
      name="Platinum"
      onDowngrade={onDowngrade}
      onHideModal={onHideModal}
      options={billing.platinumExitSurveyOptions}
      showModal={showDowngradePlatinumModal}
      subscriptionType="platinum"
    >
      Downgrading your Platinum Solo subscription will also downgrade any add-on subscriptions. You can still resume
      your subscription before the end of your current billing period. By resuming you subscription, you&apos;ll also
      have the ability to resume your add-ons.
    </ExitSurvey>
    <div className="card-body">
      <div className="d-flex flex-row mb-2">
        <h4 className="fw-bold mb-2 me-2 text-1_5">Downgrade Platinum Solo subscription</h4>
      </div>
      <div className="mb-3">
        {onTrial ? (
          <span>
            If you downgrade your Platinum Solo subscription, you&apos;ll lose access to all Platinum features and
            add-ons at the end of your trial period.
          </span>
        ) : isPastDue ? (
          <span>
            You cannot downgrade your Platinum Solo subscription while any of your subscription payments are past due.
          </span>
        ) : (
          <span>
            A scheduled end date, based on your billing cycle, will be provided if you decide to downgrade your
            subscription.
          </span>
        )}
      </div>
      <Button
        disabled={isPastDue}
        onClick={onShowDowngradePlatinumModal}
        testId="subscriptions-downgrade-subscription-card-button"
        text="bold"
        variant="border-danger"
      >
        Downgrade to Basic
      </Button>
    </div>
  </div>
);

export default DowngradePlatinumSubscription;
